module.exports = __webpack_public_path__ + "static/media/airjordan-logo-white.0dd49659.svg";